var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../LayoutDesigner/LayoutElement", "../ConfigurationDesigner/ConfigurationDesigner", "../EventEmitter", "../Models/Content/ViewPort", "vue", "./ContentSelectionController", "../Shared/NovoNoty", "../Models/Content/Sujet"], function (require, exports, LayoutElement_1, ConfigurationDesigner_1, EventEmitter_1, ViewPort_1, vue_1, ContentSelectionController_1, NovoNoty_1, Sujet_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var SujetDesignController = (function (_super) {
        __extends(SujetDesignController, _super);
        function SujetDesignController(sujetId, multiScreenId, assignedTenantId, assignedLocationId) {
            var _this = _super.call(this) || this;
            _this.contentString = "";
            _this.assignedTenantId = "";
            _this.debug = true;
            _this.layoutTemplate = '<div><div class="kachel"><div class="layout-element"><div class="TvScreenRect"></div></div><hr class="cyb-hr"/><div><span class="main-line">XXXParser</span><br/><span class="sub-line">YYYParser</span></div></div><div></div>';
            _this.containerLayoutTemplate = '<div><div style="height:30px" data-type="header"></div><div data-type="content" style="height:calc(100% - 30px)"></div></div>';
            _this.usageCountApiUrl = "/api/v1/contents/usage/{id}";
            _this.assignedLocationId = assignedLocationId;
            _this.assignedTenantId = assignedTenantId;
            _this.currentSujetId = sujetId;
            _this.currentMultiScreenId = multiScreenId;
            var host = _this;
            _this.root = $("#contentWorkSpace");
            $(window).on('OnResizeEnd', function () {
                host.configurationDesigner.RecalculateElementsTransform();
            });
            host.configurationDesigner = new ConfigurationDesigner_1.ConfigurationDesigner(_this.root, "vi");
            host.configurationDesigner.elementClassName = "";
            host.configurationDesigner.elementSelectedClassName = "";
            host.configurationDesigner.containerLayoutTemplate = _this.containerLayoutTemplate;
            host.configurationDesigner.AddEventListener(LayoutElement_1.LayoutElement.OnElementEdit, host.ElementEdit.bind(host));
            host.configurationDesigner.AllowDeepEdit = false;
            host.SetupSujetDataSource();
            host.rootVm = new vue_1.default({
                el: '#sujetDesignUI',
                data: {
                    name: "",
                    comment: "",
                    disabled: false,
                    SecurityInfoLevel: 8,
                    showModal: false,
                    usageCount: 0
                },
                components: {
                    'modal': {
                        template: '#modal-template',
                    }
                },
                computed: {
                    accessibleByUser: {
                        get: function () {
                            return this.SecurityInfoLevel === 4;
                        },
                        set: function (newValue) {
                            if (newValue)
                                this.SecurityInfoLevel = 4;
                            else
                                this.SecurityInfoLevel = 8;
                        }
                    }
                },
                methods: {
                    Save: function (event) {
                        console.log("Save");
                        host.Save();
                    },
                    SaveAndPublish: function () {
                        _this.PerformSaveAndPublish();
                    },
                    ShowDeleteConfirm: function () {
                        this.showModal = true;
                    },
                    CloseDeleteConfirm: function () {
                        this.showModal = false;
                    },
                    DeleteProceed: function () {
                        var dataItem = _this.configDataSource.at(0);
                        _this.configDataSource.remove(dataItem);
                        _this.configDataSource.sync();
                        _this.rootVm.CloseDeleteConfirm();
                    },
                }
            });
            if (host.currentSujetId !== "")
                host.Load();
            else if (host.currentMultiScreenId != "")
                host.GetMultiScreen(host.currentMultiScreenId);
            _this.GetUsageCount();
            $('#footerUi').append($('#vueButtons'));
            return _this;
        }
        SujetDesignController.prototype.GetUsageCount = function () {
            var _this = this;
            if (this.currentSujetId === "")
                return;
            $.get(this.usageCountApiUrl.replace(/{id}/g, this.currentSujetId)).done(function (response) {
                _this.rootVm.usageCount = response.Count;
            });
        };
        SujetDesignController.prototype.PerformSaveAndPublish = function () {
            var _this = this;
            var a = function () {
                _this.PerformPublish();
                console.log("remove", _this.RemoveEventListener("updated", a));
            };
            this.AddEventListener("updated", a);
            this.rootVm.Save();
        };
        SujetDesignController.prototype.PerformPublish = function () {
            console.log("publish");
            var loadingNoty = new Noty({
                text: "Der Veröffentlichungs-Prozess wurde gestartet. Haben Sie einen Moment Geduld.",
                type: 'info',
                theme: 'metroui'
            });
            var loadingNotyTimeout = window.setTimeout(function () {
                loadingNoty.show();
            }, 500);
            $.ajax({
                method: "PUT",
                url: "/api/v1/virtualscreens/updatecontent/" + this.currentSujetId,
                contentType: "application/json",
                dataType: "json"
            })
                .done(function (r) {
                new Noty({
                    text: "Der Befehl wurde erfolgreich ausgeführt. Es wurde(n) " + r.UpdatedCount + " Anzeige(n) aktualisiert.",
                    type: 'success',
                    theme: 'metroui',
                    timeout: 2000
                }).show();
            })
                .fail(function (r) {
                NovoNoty_1.NovoNoty.ShowErrorDetails(r);
            })
                .always(function () {
                window.clearTimeout(loadingNotyTimeout);
                loadingNoty.close();
            });
        };
        SujetDesignController.prototype.SetupSujetDataSource = function () {
            var host = this;
            host.configDataSource = new kendo.data.DataSource({
                transport: {
                    read: {
                        url: "/api/v1/contents/" + this.currentSujetId,
                        type: "get", dataType: "json"
                    },
                    create: {
                        url: "/api/v1/contents",
                        type: "post", dataType: "json", contentType: "application/json"
                    },
                    update: {
                        url: "/api/v1/contents",
                        type: "put", dataType: "json", contentType: "application/json"
                    },
                    destroy: {
                        url: "/api/v1/contents/" + this.currentSujetId,
                        type: "delete", dataType: "json", contentType: "application/json"
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== "read" && data) {
                            return kendo.stringify(data);
                        }
                    }
                },
                schema: {
                    type: "json",
                    model: {
                        id: "Id",
                        fields: { Id: "Id" }
                    }
                },
                change: function (e) {
                    if (this.debug) {
                        console.log("change");
                        console.log(e.items[0]);
                    }
                },
                requestEnd: function (e) {
                    if (e.type === undefined)
                        return;
                    if (this.debug) {
                        console.log("requestEnd");
                        console.log(e);
                    }
                    var response = e.response;
                    var type = e.type;
                    host.ActivateUI(true);
                    if (type === "read") {
                        host.CreateSujet(response);
                        host.SetGuiValues(response);
                    }
                    else if (type === "create") {
                        var sujet = response;
                        NovoNoty_1.NovoNoty.Show("Der Befehl wurde erfolgreich ausgeführt.");
                        window.location.replace("/Sujet/" + sujet.Id);
                    }
                    else if (e.type === "destroy")
                        new Noty({
                            text: "Der Datensatz wurde gelöscht.",
                            type: 'success',
                            theme: 'metroui',
                            timeout: 600,
                            callbacks: {
                                afterClose: function () {
                                    document.location.href = './';
                                }
                            }
                        }).show();
                    else if (e.response != undefined) {
                        console.log("reload");
                        var mScreen = JSON.parse(host.contentString);
                        host.ClearWorkspace();
                        host.CreateSujet(mScreen, response);
                        NovoNoty_1.NovoNoty.Show("Der Befehl wurde erfolgreich ausgeführt.");
                        if (e.type == "update")
                            host.FireEvent("updated");
                    }
                },
                error: function (e) {
                    if (this.debug) {
                        console.log("RemoteDataSource Error");
                        console.log(e.status);
                    }
                    NovoNoty_1.NovoNoty.ShowErrorDetails(e);
                }
            });
        };
        SujetDesignController.prototype.ActivateUI = function (active) {
            this.rootVm.disabled = !active;
        };
        SujetDesignController.prototype.SetGuiValues = function (data) {
            var sujet = data;
            this.rootVm.name = sujet.Name;
        };
        SujetDesignController.prototype.GetMultiScreen = function (id) {
            if (this.debug)
                console.log("GetMultiScreen");
            var request = $.get("/api/v1/contents/" + id);
            var host = this;
            request.done(function (data) {
                if (this.debug)
                    console.log("GetMultiScreen succeeded");
                host.CreateSujet(data);
            });
            request.fail(function (data) {
                if (this.debug)
                    console.error("GetMultiScreen failed : " + data);
            });
        };
        SujetDesignController.prototype.Save = function () {
            if (this.rootVm.name == null || this.rootVm.name == "" || this.rootVm.name == " ") {
                NovoNoty_1.NovoNoty.ShowError("Bitte geben Sie einen Namen ein.");
                return;
            }
            if (this.debug) {
                console.log("Save");
                console.log("rootLayoutElement");
                console.log(this.rootLayoutElement);
            }
            this.ActivateUI(false);
            var viewPort = this.rootLayoutElement.containerObject;
            var mScreen = viewPort.Content;
            this.contentString = JSON.stringify(mScreen);
            var data = this.configDataSource.data();
            if (data.length == 0) {
                var sujet = new Sujet_1.Sujet();
                sujet.TenantId = this.assignedTenantId;
                if (window["CanAccessAllLocations"] == true)
                    sujet.AssignedLocations = ["all"];
                else
                    sujet.AssignedLocations = this.assignedLocationId;
                if (this.debug) {
                    console.log("new");
                    console.log(mScreen.Layers);
                }
                sujet.Layers = mScreen.Layers;
                sujet.Name = this.rootVm.name;
                this.configDataSource.add(sujet);
            }
            else {
                if (this.debug)
                    console.log("update data");
                var myData = this.configDataSource.at(0);
                if (this.debug)
                    console.log(mScreen.Layers);
                myData.Layers = mScreen.Layers;
                myData.Name = this.rootVm.name;
                myData.dirty = true;
            }
            this.configDataSource.at(0).SecurityInfo.Level = this.rootVm.SecurityInfoLevel;
            if (this.debug)
                console.log("sync");
            this.configDataSource.sync();
        };
        SujetDesignController.prototype.Load = function () {
            this.configDataSource.read();
        };
        SujetDesignController.prototype.ClearWorkspace = function () {
            this.configurationDesigner.DeleteLayoutElementRecursively(this.rootLayoutElement);
        };
        SujetDesignController.prototype.CreateSujet = function (data, xhrResponse) {
            if (xhrResponse === void 0) { xhrResponse = undefined; }
            if (this.debug) {
                console.log("CreateSujet");
                console.log(data);
            }
            this.rootLayoutElement = this.configurationDesigner.CreateLayoutElementRelative(1, 1, 0, 0, this.root);
            this.rootLayoutElement.IgnoreInteractions(true);
            this.rootLayoutElement.IgnoreTapInteraction(true);
            if (data == null)
                return;
            var content = data;
            this.rootViewPort = new ViewPort_1.ViewPort();
            this.rootViewPort.Content = content;
            this.rootLayoutElement.object = content;
            this.rootVm.SecurityInfoLevel = xhrResponse != undefined ? xhrResponse.SecurityInfo.Level : data.SecurityInfo.Level;
            this.rootLayoutElement.containerObject = this.rootViewPort;
            this.configurationDesigner.CreateContentRecursively(content, this.rootViewPort, this.rootLayoutElement, 0);
            var button = $(".EditContentButton").first();
            button.hide();
            this.configurationDesigner.UnsetAllInteractions();
            this.configurationDesigner.ApplyTouchInteractionToAllElements();
            this.configurationDesigner.ApplyGridDragInteractionToAllElements(10, 10);
        };
        SujetDesignController.prototype.ElementEdit = function (sender, data) {
            if (this.debug)
                console.log("ElementEdit");
            var contentElement = data.contentElement;
            var contentSelection = new ContentSelectionController_1.ContentSelectionController();
            var host = this;
            contentSelection.AddEventListener(ContentSelectionController_1.ContentSelectionControllerEventTypes.contentSelected, function (sender, data) {
                host.configurationDesigner.SetContent(data, contentElement);
                host.configurationDesigner.UnsetAllInteractions();
                host.configurationDesigner.ApplyTouchInteractionToAllElements();
                host.configurationDesigner.ApplyGridDragInteractionToAllElements(10, 10);
            });
        };
        return SujetDesignController;
    }(EventEmitter_1.EventEmitter));
    $(function () {
        if ($("#sujetDesignUI").length > 0) {
            window["SujetDesignController0"] = new SujetDesignController(window["sujetId"], window["multiScreenId"], window["selectedTenant"], window["assignedLocation"]);
        }
    });
});
//# sourceMappingURL=SujetDesignController.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Controllers/SujetDesignController.js
// module id = 400
// module chunks = 0